/**
 * Ordinary dev requests always use Vite. The dev server owns backend selection;
 * browser storage never participates. Deployed builds use their build-time URL.
 * OAuth cookies and embedded backend pages still need the selected raw origin.
 */
import {
  isNgrokOrigin,
  normalizeDaleApiOrigin,
  withDaleApiNamespace,
} from "../config/daleApiUrl";

/** Raw base for unversioned surfaces such as CopilotKit. */
export const getDefaultApiUrl = (): string =>
  import.meta.env.DEV
    ? "/api"
    : normalizeDaleApiOrigin(import.meta.env.VITE_DALE_API_URL);

/** Edge routing prefix stays on browser requests; Vite owns local rewriting. */
export const getApiUrl = (): string => withDaleApiNamespace(getDefaultApiUrl());

/** Must match the backend host receiving OAuth callbacks and their cookies. */
export const getOAuthBindBackendUrl = (): string =>
  normalizeDaleApiOrigin(import.meta.env.VITE_DALE_API_URL);

/** Only raw-origin dev requests need browser-side tunnel headers. */
export const isNgrokUrl = (): boolean =>
  import.meta.env.DEV && isNgrokOrigin(getOAuthBindBackendUrl());

export const getNgrokFetchHeaders = (
  ngrokEnabled: boolean = isNgrokUrl(),
): Record<string, string> | undefined =>
  ngrokEnabled ? { "ngrok-skip-browser-warning": "true" } : undefined;
